import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  fetchConstructionList, 
  tryDeleteConstruction
} from 'actions/ConstructionActions';
import {fetchCompanyList} from 'actions/CompanyActions';
import ConstructionCreateModal from './ConstructionCreateModal';
import ConstructionEditModal from './ConstructionEditModal';
import ConstructionCostModal from './ConstructionCostModal';
import ConfirmDialog from 'components/Dialog/Confirm';
import {DropdownButton, MenuItem} from 'react-bootstrap';

const ConstructionTableHeader = () => (
  <thead>
    <tr>
      <th className="id">#</th>
      <th className="year">年份</th>
      <th className="name">工程</th>
      <th className="status">狀態</th>
      <th className="assign-to">執行公司</th>
      <th className="cost">總成本</th>
      <th className="cost">工數</th>
      <th className="actions"></th>
    </tr>
  </thead>
);

const StatusSelector = ({handleSwitchStatus}) => (
  <select 
    className="form-control"
    onChange={handleSwitchStatus}>
    <option value={-1}>所有工程</option>
    <option value={1}>已完成</option>
    <option value={0}>進行中</option>
  </select>
)

const YearSelector = ({years, handleSwitchYear}) => (
  <select
    className="form-control"
    onChange={handleSwitchYear}>
    <option value={-1}>所有年份</option>
    {years.map(year => (<option value={year}>{year}</option>))}
  </select>
)

const CompanySelector = ({companyList, handleSwitchCompanyID}) => (
  <select 
    className="form-control"
    onChange={handleSwitchCompanyID}>
    <option value={0}>
      所有公司
    </option>
    {companyList.map(company => (
      <option value={company.get('id')} key={company.get('id')}>
        {company.get('name')}
      </option>
    ))}
  </select>
)

class Construction extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: "DISMISS",
      workOn: 0,
      selectedYear: -1,
      selectedCompanyID: 0,
      selectedStatus: -1,
    }
  }

  confirmDelete = (cid, name) => {
    return () => {
      ConfirmDialog(`確認是否删除${name}`)
        .then(
          () => {
            this.props.dispatch(tryDeleteConstruction(cid))
          },
          () => {}
        )
    }
  }

  componentDidMount() {
    let { dispatch } = this.props;

    dispatch(fetchConstructionList());
    dispatch(fetchCompanyList());
  }

  handleSwitchYear = (e) => {
    this.setState({selectedYear: parseInt(e.target.value, 10)})
  }

  handleSwitchStatus = (e) => {
    this.setState({selectedStatus: parseInt(e.target.value, 10)})
  }

  handleSwitchCompanyID = (e) => {
    this.setState({selectedCompanyID: parseInt(e.target.value, 10)})
  }

  handleDisMissModal = () => {
    this.setState({
       modal: "DISMISS"
    })
  }

  handleEdit = (cid) => {
    return () => {
      this.setState({
        workOn: cid,
        modal: "EDIT"
      })
    }
  }

  handleNew = (e) => {
    e.preventDefault();
    this.setState({
      modal: "CREATE"
    })
  }

  handleShowCostDetail = (cid) => {
    return () => {
      this.setState({
        workOn: cid,
        modal: "COST"
      })
    }
  }

  render() {
    let {workOn, modal, selectedCompanyID, selectedStatus, selectedYear} = this.state;
    let {companyList, constructionList, paymentType, labourPayment, paymentList, totalPrice, dispatch} = this.props;

    const ConstructionTableBody = () => (
      <tbody>
        {constructionList
          .filter((construction) => {
            let assignTo = construction.get('assignTo');
            let status = construction.get('status');
            let year = construction.get('year');
            let hasCompanyFilter = selectedCompanyID !== 0;
            let hasStatusFilter = selectedStatus !== -1;
            let hasYearFilter = selectedYear !== -1;

            return !((hasCompanyFilter && assignTo !== selectedCompanyID) 
                    || (hasStatusFilter && status !== selectedStatus) 
                    || (hasYearFilter && year !== selectedYear))
          })
          .reverse()
          .map((construction) => (
            <tr key={construction.get('cid')}>
              <td>{construction.get('cid')}</td>
              <td>{construction.get('year')}</td>
              <td>{construction.get('name')}</td>
              <td>
                {(construction.get('status') === 0? "進行中" : "已完成")}
              </td>
              <td>
                {companyList.getIn([
                  companyList.findIndex(arr => 
                    arr.get('id') === construction.get('assignTo')
                  ), 
                  'name'
                ])}
              </td>
              <td>${construction.get('cost')}</td>
              <td>{construction.get('workUnits')}工</td>
              <td>
                <DropdownButton title="動作" id={construction.get('cid')}>
                  <MenuItem 
                    onClick={this.handleEdit(construction.get('cid'))} >
                    <span className="glyphicon glyphicon-pencil" />{" "}修改資料
                  </MenuItem>
                  <MenuItem 
                    onClick={this.handleShowCostDetail(construction.get('cid'))} >
                    <span className="glyphicon glyphicon-list-alt" />{" "}檢視成本
                  </MenuItem>
                  <MenuItem divider />
                  <MenuItem 
                    onClick={this.confirmDelete(construction.get('cid'), construction.get('name'))} >
                    <span className="glyphicon glyphicon-trash" />{" "}删除
                  </MenuItem>
                </DropdownButton>
              </td>
            </tr>
          ))}
      </tbody>
    );

    return (
      <div className="construction-panel">
        <div className="filter">
          <form className="form-inline">
            <CompanySelector 
              companyList={companyList}
              handleSwitchCompanyID={this.handleSwitchCompanyID} />
            {" "}
            <StatusSelector handleSwitchStatus={this.handleSwitchStatus} />
            {" "}
            <YearSelector 
              years={constructionList.reduce((s, c) => {
                let year = c.get('year');
                if (year && !s.includes(year)) s.push(year);
                return s
              }, []).sort().reverse()}
              handleSwitchYear={this.handleSwitchYear} />
            <button 
              className="btn btn-primary pull-right" 
              onClick={this.handleNew}>
              新增工程
            </button>
          </form>
        </div>
        <table className="table table-hover construction-table">
          <ConstructionTableHeader />
          <ConstructionTableBody />
        </table>
        { modal === "CREATE" &&
          <ConstructionCreateModal
            companyList={companyList}
            handleDisMissModal={this.handleDisMissModal} 
            dispatch={dispatch} />}
        { modal === "EDIT" &&
          <ConstructionEditModal
            companyList={companyList}
            handleDisMissModal={this.handleDisMissModal}
            dispatch={dispatch}
            workOn={workOn} />}
        { modal === "COST" &&
          <ConstructionCostModal 
            constructionName={constructionList
                                .get(constructionList.findIndex(construction => construction.get('cid') === workOn))
                                .get('name')} 
            handleDisMissModal={this.handleDisMissModal}
            paymentType={paymentType}
            labourPayment={labourPayment}
            paymentList={paymentList}
            totalPrice={totalPrice}
            dispatch={dispatch}
            workOn={workOn} />}
      </div>
    );
  }
}

export default connect((state) => ({
  constructionList: state.construction.get('constructionList'),
  companyList: state.company,
  paymentType: state.payment.get('typeList'),
  labourPayment: state.payment.get('labourPayment'), 
  paymentList: state.payment.get('paymentList'),
  totalPrice: state.payment.get('totalPrice')
}))(Construction);



// WEBPACK FOOTER //
// ./src/components/Construction/Construction.js